import { collections } from "@/mocks/home";

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 border-y border-foreground-950/10">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">COLLECTIONS</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              吃瓜合集速览
            </h2>
          </div>
          <p className="text-sm md:text-base leading-7 text-foreground-600 max-w-md">
            合集比碎片好读。挑一个方向进去，从头顺下来，比在入口之间来回跳要省力。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#subscribe"
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden border border-foreground-950/12 bg-background-50 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <div className="w-full sm:w-[220px] lg:w-[200px] aspect-[4/3] sm:aspect-auto sm:h-auto shrink-0 bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}封面图`}
                  title={`${item.title} · 黑料免费攻略合集`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <p className="text-xs text-foreground-500">{item.meta}</p>
                <h3 className="mt-2 font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-6 text-foreground-600">{item.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  进入合集
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}